import React from 'react';

interface FeaturedImageHeaderProps {
  imageUrl?: string | null;
  title: string;
  className?: string;
}

// Solofix Neon fallback-gradients (zie DESIGN-SYSTEM.md, Event-kaarten)
const NEON_GRADIENTS = [
  'linear-gradient(120deg,#ff8a3d,#ff3d81 55%,#7a3dff)',
  'linear-gradient(120deg,#23e5db,#3d7bff 55%,#7a3dff)',
  'linear-gradient(120deg,#b8ff3d,#23e5db 55%,#3d7bff)',
];

// Deterministische keuze op basis van de titel, zodat elke kaart
// consistent dezelfde gradient krijgt maar het grid varieert.
const gradientForTitle = (title: string) => {
  let hash = 0;
  for (let i = 0; i < title.length; i++) {
    hash = (hash + title.charCodeAt(i)) % 997;
  }
  return NEON_GRADIENTS[hash % NEON_GRADIENTS.length];
};

export const FeaturedImageHeader: React.FC<FeaturedImageHeaderProps> = ({
  imageUrl,
  title,
  className = ''
}) => {
  return (
    <div className={`h-[150px] relative overflow-hidden ${className}`}>
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={title}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      ) : (
        <div
          className="w-full h-full"
          style={{ background: gradientForTitle(title) }}
          aria-label={title}
        />
      )}
    </div>
  );
};

export default FeaturedImageHeader;
